import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94.68 77.06"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M94.65 0c-4.07 3.93-5.81 8.36-20.03 10.81-12.88 2.21-24.77 7.34-24.77 23.52v42.73l5.74-5.15V56.45c0-9.06 7.4-15.17 17.21-20.95C98.02 20.66 94.34 10.65 94.66 0Z",
      style: {"fill":"#ee8301"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M.03 0C4.1 3.93 5.84 8.36 20.06 10.81c12.88 2.21 24.77 7.34 24.77 23.52v42.73l-5.74-5.15V56.45c0-9.06-7.4-15.17-17.21-20.95C-3.33 20.65.34 10.64.03 0Z",
      style: {"fill":"#672275"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "YE-logo"}) } }